import { gql } from '@apollo/client';

export const userFormData = gql`
  {
    departments: readDepartments {
      id
      Name
    }
    roles: readAllRoles {
      id
      roleType
    }
  }
`;
